import React, { FC } from 'react';
import classNames from 'classnames';
import TextField from 'e100-react-components/lib/components/TextField';
import { IPropTypes } from 'e100-react-components/lib/components/TextField';

import useStyles from './useStyles';

const FilledTextFiled: FC<IPropTypes> = (props) => {
  const classes = useStyles();
  const { InputProps, ...otherProps } = props;
  const { startAdornment, ...otherInputProps } = InputProps || {};

  return (
    <div className={classes.container}>
      {
        startAdornment && (
          <div className={classes.iconContainer}>
            <>{startAdornment}</>
          </div>
        )
      }
      <TextField
        {...otherProps}
        InputProps={{
          ...(otherInputProps || {})
        }}
        variant="filled"
        classes={{
          root: classNames({
            [classes.root]: true,
            [classes.rootWithIcon]: startAdornment
          })
        }}
      />
    </div>
  );
};

export default FilledTextFiled;
